import { Container, Heading, Stack, Text } from '@apps/ui';
import { useRouter } from '@tanstack/react-router';

export function RouteErrorBoundary({ error }: { error: Error }) {
  const router = useRouter();
  return (
    <Container>
      <Stack gap="lg">
        <Heading level="h1">エラーが発生しました</Heading>
        <Text tone="muted">{error.message}</Text>
        <button
          type="button"
          onClick={() => router.invalidate()}
          style={{
            alignSelf: 'flex-start',
            padding: '8px 16px',
            borderRadius: 8,
            border: '1px solid currentColor',
            background: 'transparent',
            color: 'inherit',
          }}
        >
          再試行
        </button>
      </Stack>
    </Container>
  );
}

export function NotFound() {
  return (
    <Container>
      <Stack gap="md">
        <Heading level="h1">ページが見つかりません</Heading>
        <Text tone="muted">URL を確認してください。</Text>
      </Stack>
    </Container>
  );
}
